import { Controller } from '@hotwired/stimulus'

// Page-header 'Filtres' button. Asks the filters panel to show/hide itself by
// dispatching a window event (admin-filters-toggle:toggle) that the panel listens for.
// Used across every back-office index.
export default class extends Controller {
  toggle() {
    const expanded = this.element.getAttribute('aria-expanded') === 'true'
    this.element.setAttribute('aria-expanded', (!expanded).toString())
    this.dispatch('toggle')
  }
}
